var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

$(window).load(function () {
  //disable tracking for inshape since its missing the appropriate controller
  if (Math.random() > 0.8 && typeof window.performance !== 'undefined' && window.location.hostname.indexOf('inshape') < 0) {
    sw.track('page_load', {
      loadStart:         window.performance.timing.fetchStart,
      dnsComplete:       window.performance.timing.domainLookupEnd,
      responseComplete:  window.performance.timing.responseEnd,
      domLoaded:         window.performance.timing.domContentLoadedEventStart,
      domInteractive:    window.performance.timing.domInteractive,
      pageLoaded:        window.performance.timing.loadEventStart
    });
  }
});
